/* eslint-disable require-jsdoc */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Button, Text, Theme, Modal, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { globalStyles } from '../../../../theme/index.js';
import { updateFormField } from '../../../../actions/signup.js';
import * as notifier from '../../../../actions/notifier.js';
import { Check as CheckIcon, Stars as StarsIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import DentalDetails from './DentalDetails.js';
import DrugsDetails from './DrugsDetails.js';
import HealthcareDetails from './HealthcareDetails.js';
import SpendingAccountDetails from './SpendingAccountDetails.js';
import { helpers } from '@simplybenefits/sb-utils';


// Component for tier selection
const SelectedStyle = (props) => {
    const theme = useTheme();
    const styles = {
        block: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            flex: 0.33,
            margin: 5,
            height: 260,
            overflow: 'auto',
            borderRadius: 20,
            cursor: 'pointer',
            border: `1.5px solid ${ theme.palette.primary.main }`
        },
        selectedBlock: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            flex: 0.33,
            margin: 5,
            height: 260,
            overflow: 'auto',
            borderRadius: 20,
            border: `2px solid ${ theme.palette.primary.main }`,
            backgroundColor: theme.palette.primary.light,
            cursor: 'pointer',
            zIndex: 0
        }
    };

    if (props.selected) {
        return <div style={styles.selectedBlock}>{props.children}</div>; 
    }

    return <div style={styles.block}>{props.children}</div>; 
};

class ModularFlexSelection extends PureComponent {
    state = {
        health: null,
        dental: null,
        showDetails: false,
        modalTitle: null,
        modalType: null,
        modalTier: null,
        modalTierColor: null
    };

    componentDidMount() {
        if (this.props.modularFlexSelection) {
            this.setState({
                health: this.props.modularFlexSelection.health,
                dental: this.props.modularFlexSelection.dental
            });
        }
    }

    _next = () => {
        if (!this.state.health || !this.state.dental) {
            this.props.dispatch(notifier.displayError({
                verbiage: i18n.t(tokens.labels.signup.youMustSelectHealthAndDental)
            }));

            return;
        }

        // mark the saved state to true, we have hit next and everything is valid
        this.props.setSavedState('modularFlexSelection', true);

        this.props.stepCompletion(
            {
                health: this.state.health,
                dental: this.state.dental
            },
            'modularFlexSelection',
            false
        );
    };

    _selectTier = async (type, tier) => {
        // if the member is only allowed a single tier selection then set their selected tier for both health and dental
        if (this.props.modularFlexTiers.combinedTierSelection) {
            await this.props.dispatch(updateFormField('modularFlexSelection', 'dental', tier));
            await this.props.dispatch(updateFormField('modularFlexSelection', 'health', tier));

            this.setState({
                health: tier,
                dental: tier
            });

            return;
        }

        await this.props.dispatch(updateFormField('modularFlexSelection', type, tier));

        this.setState({
            [type]: tier
        });

    };

    _toggleDetails = (modalType, modalTier, modalTierColor, modalTitle) => {
        if (modalType) {
            this.setState({
                showDetails: true,
                modalTitle,
                modalType,
                modalTier,
                modalTierColor
            });
        } else {
            this.setState({
                showDetails: false,
                modalTitle: null,
                modalType: null,
                modalTier: null,
                modalTierColor: null
            });
        }
    };

    _buildDetails = (data, type) => {
        if (!data.isSelected) {
            return (
                <div style={{ whiteSpace: 'pre-line', maxHeight: 350, overflow: 'auto' }}>
                    <Text align="center" mediumLarge>N/A</Text>
                </div>
            );
        }

        switch (type) {
            case 'dental':
                return <DentalDetails data={data} />;
            case 'drugs':
                return <DrugsDetails data={data} />;
            case 'healthcare':
                return <HealthcareDetails data={data} />;
            case 'spendingAccounts':
                return <SpendingAccountDetails data={ data } />;
            default:
                return null;
        }
    };

    render() {
        const styles = {
            blocks: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center'
            },
            block: {
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                margin: 5,
                height: 220,
                overflow: 'auto',
                border: `2px solid ${ Theme.colors.lightGrey }`,
                borderRadius: 20,
                cursor: 'pointer'
            },
            form: {
                display: 'flex',
                flexDirection: 'column'
            },
            stepperBackBtn: {
                margin: '0px auto 0px 0px !important'
            },
            signature: {
                fontFamily: 'AntaraDistance !important',
                fontWeight: 'bold',
                fontSize: 20,
                paddingBottom: 0
            },
            stepperNextBtn: globalStyles.stepperNextBtn,
            stepperBtnContainer: globalStyles.stepperBtnContainer,
            outerBlock: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                paddingTop: 10
            },
            innerBlock: {
                padding: "0 20px"
            },
            innerBlockTextRow: {
                marginTop: 10,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
            },
            detailsBtn: {
                width: "100px",
                padding: "1px 16px",
                margin: "0 auto 15px auto",
                fontSize: "12px"
            },
            titleBlock: {
                display: 'flex',
                flexDirection: 'row',
                padding: "20px 20px 0 20px"
            },
            clickableArea: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column'
            }
        };

        return (
            <div>
                <Text largest bold margin="0 0 10px 0">{ i18n.t(tokens.labels.signup.planSelection) }</Text>

                {
                    this.props.modularFlexTiers.combinedTierSelection ?
                        <>
                            <div style={styles.form}>
                                <Text small margin="0 0 10px 0">{ i18n.t(tokens.labels.signup.youHaveBeenGivenAModFlexAccount) }</Text>

                                <div style={ styles.blocks }>
                                    <SelectedStyle selected={this.state.health === 'gold'} tier="gold">
                                        <div style={ styles.clickableArea } onClick={() => this._selectTier('health', 'gold')}>
                                            <div style={ styles.titleBlock }>
                                                <StarsIcon style={{ color: Theme.colors.skyBlue, marginTop: 5 }} fontSize="medium" />

                                                <div>
                                                    <Text bold mediumLarge>{ this.props.modularFlexTiers.tier1 }</Text>
                                                    <Text superTiny bold color={Theme.colors.skyBlue} margin="-5px 0 0 0">{ i18n.t(tokens.titles.coverage) }</Text>
                                                </div>
                                            </div>

                                            <div style={ styles.outerBlock }>
                                                <div style={ styles.innerBlock }>
                                                    {
                                                        this.props.blueprint.health.gold.drugs.isSelected &&
                                                            <div style={ styles.innerBlockTextRow }>
                                                                <CheckIcon color="primary" fontSize="small" />
                                                                <Text small>
                                                                    {
                                                                        this.props.blueprint.health.gold.drugs.isGraded ?
                                                                            this.props.blueprint.health.gold.drugs.firstPercentage
                                                                            :
                                                                            this.props.blueprint.health.gold.drugs.reimbursement
                                                                    }
                                                                    % { i18n.t(tokens.labels.signup.drug) }
                                                                </Text>
                                                            </div>
                                                    }

                                                    {
                                                        this.props.blueprint.health.gold.healthcare.isSelected &&
                                                            <div style={ styles.innerBlockTextRow }>
                                                                <CheckIcon color="primary" fontSize="small" />
                                                                <Text small>{ this.props.blueprint.health.gold.healthcare.paramedicalReimbursement }% { i18n.t(tokens.titles.paramedical) }</Text>
                                                            </div>
                                                    }

                                                    {
                                                        this.props.blueprint.health.gold.healthcare.includeEyeExams &&
                                                            <div style={ styles.innerBlockTextRow }>
                                                                <CheckIcon color="primary" fontSize="small" />
                                                                <Text small>{ this.props.blueprint.health.gold.healthcare.eyeExamReimbursement }% { i18n.t(tokens.dropdowns.benefits.eyeExam) }</Text>
                                                            </div>
                                                    }

                                                    {
                                                        this.props.blueprint.health.gold.spendingAccounts.isSelected &&
                                                        <>
                                                            {
                                                                this.props.blueprint.health.gold.spendingAccounts.isPooled ?
                                                                    <div style={ styles.innerBlockTextRow }>
                                                                        <CheckIcon color="primary" fontSize="small" />
                                                                        <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.gold.spendingAccounts.pooledAmountAvailable) } { i18n.t(tokens.labels.signup.flexSpendingAccount) }</Text>
                                                                    </div>
                                                                    :
                                                                    <div style={ styles.innerBlockTextRow }>
                                                                        <CheckIcon color="primary" fontSize="small" />
                                                                        <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.gold.spendingAccounts.hsaAmount) } HSA</Text>
                                                                    </div>
                                                            }
                                                        </>
                                                    }

                                                    {
                                                        this.props.blueprint.dental.gold.includeBasic &&
                                                            <div style={ styles.innerBlockTextRow }>
                                                                <CheckIcon color="primary" fontSize="small" />
                                                                <Text small>{ this.props.blueprint.dental.gold.basicReimbursement }% { i18n.t(tokens.labels.signup.basicDental) }</Text>
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <Button
                                            color="primary"
                                            onClick={() => this._toggleDetails('health', 'gold', Theme.colors.skyBlue, `${ this.props.modularFlexTiers.tier1 } ${ i18n.t(tokens.titles.health) }`)}
                                            customStyle={ styles.detailsBtn }
                                        >
                                            { i18n.t(tokens.titles.details) }
                                        </Button>
                                    </SelectedStyle>

                                    <SelectedStyle selected={this.state.health === 'silver'} tier="silver">
                                        <div style={ styles.clickableArea } onClick={() => this._selectTier('health', 'silver')}>
                                            <div style={ styles.titleBlock }>
                                                <StarsIcon style={{ color: Theme.colors.skyBlue, marginTop: 5 }} fontSize="medium" />

                                                <div>
                                                    <Text bold mediumLarge>{ this.props.modularFlexTiers.tier2 }</Text>
                                                    <Text superTiny bold color={Theme.colors.skyBlue} margin="-5px 0 0 0">{ i18n.t(tokens.titles.coverage) }</Text>
                                                </div>
                                            </div>

                                            <div style={ styles.outerBlock }>
                                                <div style={ styles.innerBlock }>
                                                    {
                                                        this.props.blueprint.health.silver.drugs.isSelected &&
                                                        <div style={ styles.innerBlockTextRow }>
                                                            <CheckIcon color="primary" fontSize="small" />
                                                            <Text small>
                                                                {
                                                                    this.props.blueprint.health.silver.drugs.isGraded ?
                                                                        this.props.blueprint.health.silver.drugs.firstPercentage
                                                                        :
                                                                        this.props.blueprint.health.silver.drugs.reimbursement
                                                                }
                                                                % { i18n.t(tokens.labels.signup.drug) }
                                                            </Text>
                                                        </div>
                                                    }

                                                    {
                                                        this.props.blueprint.health.silver.healthcare.isSelected &&
                                                        <div style={ styles.innerBlockTextRow }>
                                                            <CheckIcon color="primary" fontSize="small" />
                                                            <Text small>{ this.props.blueprint.health.silver.healthcare.paramedicalReimbursement }% { i18n.t(tokens.titles.paramedical) }</Text>
                                                        </div>
                                                    }

                                                    {
                                                        this.props.blueprint.health.silver.healthcare.includeEyeExams &&
                                                        <div style={ styles.innerBlockTextRow }>
                                                            <CheckIcon color="primary" fontSize="small" />
                                                            <Text small>{ this.props.blueprint.health.silver.healthcare.eyeExamReimbursement }% { i18n.t(tokens.dropdowns.benefits.eyeExam) }</Text>
                                                        </div>
                                                    }

                                                    {
                                                        this.props.blueprint.health.silver.spendingAccounts.isSelected &&
                                                        <>
                                                            {
                                                                this.props.blueprint.health.silver.spendingAccounts.isPooled ?
                                                                    <div style={ styles.innerBlockTextRow }>
                                                                        <CheckIcon color="primary" fontSize="small" />
                                                                        <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.silver.spendingAccounts.pooledAmountAvailable) } { i18n.t(tokens.labels.signup.flexSpendingAccount) }</Text>
                                                                    </div>
                                                                    :
                                                                    <div style={ styles.innerBlockTextRow }>
                                                                        <CheckIcon color="primary" fontSize="small" />
                                                                        <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.silver.spendingAccounts.hsaAmount) } HSA</Text>
                                                                    </div>
                                                            }
                                                        </>
                                                    }

                                                    {
                                                        this.props.blueprint.dental.silver.includeBasic &&
                                                        <div style={ styles.innerBlockTextRow }>
                                                            <CheckIcon color="primary" fontSize="small" />
                                                            <Text small>{ this.props.blueprint.dental.silver.basicReimbursement }% { i18n.t(tokens.labels.signup.basicDental) }</Text>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <Button
                                            color="primary"
                                            onClick={() => this._toggleDetails('health', 'silver', Theme.colors.skyBlue, `${ this.props.modularFlexTiers.tier2 } ${ i18n.t(tokens.titles.health) }`)}
                                            customStyle={ styles.detailsBtn }
                                        >
                                            { i18n.t(tokens.titles.details) }
                                        </Button>
                                    </SelectedStyle>

                                    {
                                        this.props.modularFlexTiers.numberOfTiers === 3 &&
                                        <SelectedStyle selected={this.state.health === "bronze"} tier="bronze">
                                            <div style={ styles.clickableArea } onClick={() => this._selectTier('health', 'bronze')}>
                                                <div style={ styles.titleBlock }>
                                                    <StarsIcon style={{ color: Theme.colors.skyBlue, marginTop: 5 }} fontSize="medium" />

                                                    <div>
                                                        <Text bold mediumLarge>{ this.props.modularFlexTiers.tier3 }</Text>
                                                        <Text superTiny bold color={Theme.colors.skyBlue} margin="-5px 0 0 0">{ i18n.t(tokens.titles.coverage) }</Text>
                                                    </div>
                                                </div>

                                                <div style={ styles.outerBlock }>
                                                    <div style={ styles.innerBlock }>
                                                        {
                                                            this.props.blueprint.health.bronze.drugs.isSelected &&
                                                                <div style={ styles.innerBlockTextRow }>
                                                                    <CheckIcon color="primary" fontSize="small" />
                                                                    <Text small>
                                                                        {
                                                                            this.props.blueprint.health.bronze.drugs.isGraded ?
                                                                                this.props.blueprint.health.bronze.drugs.firstPercentage
                                                                                :
                                                                                this.props.blueprint.health.bronze.drugs.reimbursement
                                                                        }% { i18n.t(tokens.labels.signup.drug) }
                                                                    </Text>
                                                                </div>
                                                        }

                                                        {
                                                            this.props.blueprint.health.bronze.healthcare.isSelected &&
                                                                <div style={ styles.innerBlockTextRow }>
                                                                    <CheckIcon color="primary" fontSize="small" />
                                                                    <Text small>{ this.props.blueprint.health.bronze.healthcare.paramedicalReimbursement }% { i18n.t(tokens.titles.paramedical) }</Text>
                                                                </div>
                                                        }

                                                        {
                                                            this.props.blueprint.health.bronze.healthcare.includeEyeExams &&
                                                                <div style={ styles.innerBlockTextRow }>
                                                                    <CheckIcon color="primary" fontSize="small" />
                                                                    <Text small>{ this.props.blueprint.health.bronze.healthcare.eyeExamReimbursement }% { i18n.t(tokens.dropdowns.benefits.eyeExam) }</Text>
                                                                </div>
                                                        }

                                                        {
                                                            this.props.blueprint.health.bronze.spendingAccounts.isSelected &&
                                                            <>
                                                                {
                                                                    this.props.blueprint.health.bronze.spendingAccounts.isPooled ?
                                                                        <div style={ styles.innerBlockTextRow }>
                                                                            <CheckIcon color="primary" fontSize="small" />
                                                                            <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.bronze.spendingAccounts.pooledAmountAvailable) } { i18n.t(tokens.labels.signup.flexSpendingAccount) }</Text>
                                                                        </div>
                                                                        :
                                                                        <div style={ styles.innerBlockTextRow }>
                                                                            <CheckIcon color="primary" fontSize="small" />
                                                                            <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.bronze.spendingAccounts.hsaAmount) } HSA</Text>
                                                                        </div>
                                                                }
                                                            </>
                                                        }

                                                        {
                                                            this.props.blueprint.dental.bronze.includeBasic &&
                                                                <div style={ styles.innerBlockTextRow }>
                                                                    <CheckIcon color="primary" fontSize="small" />
                                                                    <Text small>{ this.props.blueprint.dental.bronze.basicReimbursement }% { i18n.t(tokens.labels.signup.basicDental) }</Text>
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <Button
                                                color="primary"
                                                onClick={() => this._toggleDetails('health', 'bronze', Theme.colors.skyBlue, `${ this.props.modularFlexTiers.tier3 } ${ i18n.t(tokens.titles.health) }`)}
                                                customStyle={ styles.detailsBtn }
                                            >
                                                { i18n.t(tokens.titles.details) }
                                            </Button>
                                        </SelectedStyle>
                                    }
                                </div>

                                <div style={styles.stepperBtnContainer}>
                                    <Button
                                        style={styles.stepperNextBtn}
                                        onClick={this._next}
                                        color="primary"
                                    >
                                        { i18n.t(tokens.buttons.continue) }
                                    </Button>
                                </div>
                            </div>
                        </>
                        :
                        <div style={styles.form}>
                            <Text small margin="0 0 10px 0">{ i18n.t(tokens.labels.signup.youHaveBeenGivenAModFlexAccount) }</Text>

                            <Text large bold margin="0 0 10px 0">{ i18n.t(tokens.titles.health) }</Text>

                            <div style={ styles.blocks }>
                                <SelectedStyle selected={this.state.health === 'gold'} tier="gold">
                                    <div style={ styles.clickableArea } onClick={() => this._selectTier('health', 'gold')}>
                                        <div style={ styles.titleBlock }>
                                            <StarsIcon style={{ color: Theme.colors.skyBlue, marginTop: 5 }} fontSize="medium" />

                                            <div>
                                                <Text bold mediumLarge>{ this.props.modularFlexTiers.tier1 }</Text>
                                                <Text superTiny bold color={Theme.colors.skyBlue} margin="-5px 0 0 0">{ i18n.t(tokens.titles.coverage) }</Text>
                                            </div>
                                        </div>

                                        <div style={ styles.outerBlock }>
                                            <div style={ styles.innerBlock }>
                                                {
                                                    this.props.blueprint.health.gold.drugs.isSelected &&
                                                    <div style={ styles.innerBlockTextRow }>
                                                        <CheckIcon color="primary" fontSize="small" />
                                                        <Text small>
                                                            {
                                                                this.props.blueprint.health.gold.drugs.isGraded ?
                                                                    this.props.blueprint.health.gold.drugs.firstPercentage
                                                                    :
                                                                    this.props.blueprint.health.gold.drugs.reimbursement
                                                            }
                                                            % { i18n.t(tokens.labels.signup.drug) }
                                                        </Text>
                                                    </div>
                                                }

                                                {
                                                    this.props.blueprint.health.gold.healthcare.isSelected &&
                                                        <div style={ styles.innerBlockTextRow }>
                                                            <CheckIcon color="primary" fontSize="small" />
                                                            <Text small>{ this.props.blueprint.health.gold.healthcare.paramedicalReimbursement }% { i18n.t(tokens.titles.paramedical) }</Text>
                                                        </div>
                                                }

                                                {
                                                    this.props.blueprint.health.gold.healthcare.includeEyeExams &&
                                                        <div style={ styles.innerBlockTextRow }>
                                                            <CheckIcon color="primary" fontSize="small" />
                                                            <Text small>{ this.props.blueprint.health.gold.healthcare.eyeExamReimbursement }% { i18n.t(tokens.dropdowns.benefits.eyeExam) }</Text>
                                                        </div>
                                                }

                                                {
                                                    this.props.blueprint.health.gold.spendingAccounts.isSelected &&
                                                    <>
                                                        {
                                                            this.props.blueprint.health.gold.spendingAccounts.isPooled ?
                                                                <div style={ styles.innerBlockTextRow }>
                                                                    <CheckIcon color="primary" fontSize="small" />
                                                                    <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.gold.spendingAccounts.pooledAmountAvailable) } { i18n.t(tokens.labels.signup.flexSpendingAccount) }</Text>
                                                                </div>
                                                                :
                                                                <div style={ styles.innerBlockTextRow }>
                                                                    <CheckIcon color="primary" fontSize="small" />
                                                                    <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.gold.spendingAccounts.hsaAmount) } HSA</Text>
                                                                </div>
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <Button
                                        color="primary"
                                        onClick={() => this._toggleDetails('health', 'gold', Theme.colors.skyBlue, `${ this.props.modularFlexTiers.tier1 } ${ i18n.t(tokens.titles.health) }`)}
                                        customStyle={ styles.detailsBtn }
                                    >
                                        { i18n.t(tokens.titles.details) }
                                    </Button>
                                </SelectedStyle>

                                <SelectedStyle selected={this.state.health === 'silver'} tier="silver">
                                    <div style={ styles.clickableArea } onClick={() => this._selectTier('health', 'silver')}>
                                        <div style={ styles.titleBlock }>
                                            <StarsIcon style={{ color: Theme.colors.skyBlue, marginTop: 5 }} fontSize="medium" />

                                            <div>
                                                <Text bold mediumLarge>{ this.props.modularFlexTiers.tier2 }</Text>
                                                <Text superTiny bold color={Theme.colors.skyBlue} margin="-5px 0 0 0">{ i18n.t(tokens.titles.coverage) }</Text>
                                            </div>
                                        </div>

                                        <div style={ styles.outerBlock }>
                                            <div style={ styles.innerBlock }>
                                                {
                                                    this.props.blueprint.health.silver.drugs.isSelected &&
                                                    <div style={ styles.innerBlockTextRow }>
                                                        <CheckIcon color="primary" fontSize="small" />
                                                        <Text small>
                                                            {
                                                                this.props.blueprint.health.silver.drugs.isGraded ?
                                                                    this.props.blueprint.health.silver.drugs.firstPercentage
                                                                    :
                                                                    this.props.blueprint.health.silver.drugs.reimbursement
                                                            }
                                                            % { i18n.t(tokens.labels.signup.drug) }
                                                        </Text>
                                                    </div>
                                                }

                                                {
                                                    this.props.blueprint.health.silver.healthcare.isSelected &&
                                                    <div style={ styles.innerBlockTextRow }>
                                                        <CheckIcon color="primary" fontSize="small" />
                                                        <Text small>{ this.props.blueprint.health.silver.healthcare.paramedicalReimbursement }% { i18n.t(tokens.titles.paramedical) }</Text>
                                                    </div>
                                                }

                                                {
                                                    this.props.blueprint.health.silver.healthcare.includeEyeExams &&
                                                    <div style={ styles.innerBlockTextRow }>
                                                        <CheckIcon color="primary" fontSize="small" />
                                                        <Text small>{ this.props.blueprint.health.silver.healthcare.eyeExamReimbursement }% { i18n.t(tokens.dropdowns.benefits.eyeExam) }</Text>
                                                    </div>
                                                }

                                                {
                                                    this.props.blueprint.health.silver.spendingAccounts.isSelected &&
                                                    <>
                                                        {
                                                            this.props.blueprint.health.silver.spendingAccounts.isPooled ?
                                                                <div style={ styles.innerBlockTextRow }>
                                                                    <CheckIcon color="primary" fontSize="small" />
                                                                    <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.silver.spendingAccounts.pooledAmountAvailable) } { i18n.t(tokens.labels.signup.flexSpendingAccount) }</Text>
                                                                </div>
                                                                :
                                                                <div style={ styles.innerBlockTextRow }>
                                                                    <CheckIcon color="primary" fontSize="small" />
                                                                    <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.silver.spendingAccounts.hsaAmount) } HSA</Text>
                                                                </div>
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <Button
                                        color="primary"
                                        onClick={() => this._toggleDetails('health', 'silver', Theme.colors.skyBlue, `${ this.props.modularFlexTiers.tier2 } ${ i18n.t(tokens.titles.health) }`)}
                                        customStyle={ styles.detailsBtn }
                                    >
                                        { i18n.t(tokens.titles.details) }
                                    </Button>
                                </SelectedStyle>

                                {
                                    this.props.modularFlexTiers.numberOfTiers === 3 &&
                                        <SelectedStyle selected={this.state.health === "bronze"} tier="bronze">
                                            <div style={ styles.clickableArea } onClick={() => this._selectTier('health', 'bronze')}>
                                                <div style={ styles.titleBlock }>
                                                    <StarsIcon style={{ color: Theme.colors.skyBlue, marginTop: 5 }} fontSize="medium" />

                                                    <div>
                                                        <Text bold mediumLarge>{ this.props.modularFlexTiers.tier3 }</Text>
                                                        <Text superTiny bold color={Theme.colors.skyBlue} margin="-5px 0 0 0">{ i18n.t(tokens.titles.coverage) }</Text>
                                                    </div>
                                                </div>

                                                <div style={ styles.outerBlock }>
                                                    <div style={ styles.innerBlock }>
                                                        {
                                                            this.props.blueprint.health.bronze.drugs.isSelected &&
                                                            <div style={ styles.innerBlockTextRow }>
                                                                <CheckIcon color="primary" fontSize="small" />
                                                                <Text small>
                                                                    {
                                                                        this.props.blueprint.health.bronze.drugs.isGraded ?
                                                                            this.props.blueprint.health.bronze.drugs.firstPercentage
                                                                            :
                                                                            this.props.blueprint.health.bronze.drugs.reimbursement
                                                                    }% { i18n.t(tokens.labels.signup.drug) }
                                                                </Text>
                                                            </div>
                                                        }

                                                        {
                                                            this.props.blueprint.health.bronze.healthcare.isSelected &&
                                                            <div style={ styles.innerBlockTextRow }>
                                                                <CheckIcon color="primary" fontSize="small" />
                                                                <Text small>{ this.props.blueprint.health.bronze.healthcare.paramedicalReimbursement }% { i18n.t(tokens.titles.paramedical) }</Text>
                                                            </div>
                                                        }

                                                        {
                                                            this.props.blueprint.health.bronze.healthcare.includeEyeExams &&
                                                            <div style={ styles.innerBlockTextRow }>
                                                                <CheckIcon color="primary" fontSize="small" />
                                                                <Text small>{ this.props.blueprint.health.bronze.healthcare.eyeExamReimbursement }% { i18n.t(tokens.dropdowns.benefits.eyeExam) }</Text>
                                                            </div>
                                                        }

                                                        {
                                                            this.props.blueprint.health.bronze.spendingAccounts.isSelected &&
                                                            <>
                                                                {
                                                                    this.props.blueprint.health.bronze.spendingAccounts.isPooled ?
                                                                        <div style={ styles.innerBlockTextRow }>
                                                                            <CheckIcon color="primary" fontSize="small" />
                                                                            <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.bronze.spendingAccounts.pooledAmountAvailable) } { i18n.t(tokens.labels.signup.flexSpendingAccount) }</Text>
                                                                        </div>
                                                                        :
                                                                        <div style={ styles.innerBlockTextRow }>
                                                                            <CheckIcon color="primary" fontSize="small" />
                                                                            <Text small>${ helpers.numberWithCommas(this.props.blueprint.health.bronze.spendingAccounts.hsaAmount) } HSA</Text>
                                                                        </div>
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <Button
                                                color="primary"
                                                onClick={() => this._toggleDetails('health', 'bronze', Theme.colors.skyBlue, `${ this.props.modularFlexTiers.tier3 } ${ i18n.t(tokens.titles.health) }`)}
                                                customStyle={ styles.detailsBtn }
                                            >
                                                { i18n.t(tokens.titles.details) }
                                            </Button>
                                        </SelectedStyle>
                                }
                            </div>

                            <Text large bold margin="10px 0 10px 0">{ i18n.t(tokens.titles.dental) }</Text>

                            <div style={ styles.blocks }>
                                <SelectedStyle selected={this.state.dental === "gold"} tier="gold">
                                    <div style={ styles.clickableArea } onClick={() => this._selectTier('dental', 'gold')}>
                                        <div style={ styles.titleBlock }>
                                            <StarsIcon style={{ color: Theme.colors.skyBlue, marginTop: 5 }} fontSize="medium" />

                                            <div>
                                                <Text bold mediumLarge>{ this.props.modularFlexTiers.tier1 }</Text>
                                                <Text superTiny bold color={Theme.colors.skyBlue} margin="-5px 0 0 0">{ i18n.t(tokens.titles.coverage) }</Text>
                                            </div>
                                        </div>

                                        <div style={ styles.outerBlock }>
                                            <div style={ styles.innerBlock }>
                                                {
                                                    (this.props.blueprint.dental.gold.isSelected && this.props.blueprint.dental.gold.includeBasic) &&
                                                        <div style={ styles.innerBlockTextRow }>
                                                            <CheckIcon color="primary" fontSize="small" />
                                                            <Text small>{ this.props.blueprint.dental.gold.basicReimbursement }% { i18n.t(tokens.labels.signup.basicDental) }</Text>
                                                        </div>
                                                }

                                                {
                                                    (this.props.blueprint.dental.gold.isSelected && this.props.blueprint.dental.gold.includeMajor) &&
                                                        <div style={ styles.innerBlockTextRow }>
                                                            <CheckIcon color="primary" fontSize="small" />
                                                            <Text small>{ this.props.blueprint.dental.gold.majorReimbursement }% { i18n.t(tokens.labels.signup.majorDental) }</Text>
                                                        </div>
                                                }

                                                {
                                                    (this.props.blueprint.dental.gold.isSelected && this.props.blueprint.dental.gold.includeOrthodontics) &&
                                                        <div style={ styles.innerBlockTextRow }>
                                                            <CheckIcon color="primary" fontSize="small" />
                                                            <Text small>{ this.props.blueprint.dental.gold.orthodonticReimbursement }% { i18n.t(tokens.dropdowns.benefits.orthodontics) }</Text>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <Button
                                        color="primary"
                                        onClick={() => this._toggleDetails('dental', 'gold', Theme.colors.skyBlue, `${ this.props.modularFlexTiers.tier1 } ${ i18n.t(tokens.titles.dental) }`)}
                                        customStyle={ styles.detailsBtn }
                                    >
                                        { i18n.t(tokens.titles.details) }
                                    </Button>
                                </SelectedStyle>

                                <SelectedStyle selected={this.state.dental === "silver"} tier="silver">
                                    <div style={ styles.clickableArea } onClick={() => this._selectTier('dental', 'silver')}>
                                        <div style={ styles.titleBlock }>
                                            <StarsIcon style={{ color: Theme.colors.skyBlue, marginTop: 5 }} fontSize="medium" />

                                            <div>
                                                <Text bold mediumLarge>{ this.props.modularFlexTiers.tier2 }</Text>
                                                <Text superTiny bold color={Theme.colors.skyBlue} margin="-5px 0 0 0">{ i18n.t(tokens.titles.coverage) }</Text>
                                            </div>
                                        </div>

                                        <div style={ styles.outerBlock }>
                                            <div style={ styles.innerBlock }>
                                                {
                                                    (this.props.blueprint.dental.silver.isSelected && this.props.blueprint.dental.silver.includeBasic) &&
                                                    <div style={ styles.innerBlockTextRow }>
                                                        <CheckIcon color="primary" fontSize="small" />
                                                        <Text small>{ this.props.blueprint.dental.silver.basicReimbursement }% { i18n.t(tokens.labels.signup.basicDental) }</Text>
                                                    </div>
                                                }

                                                {
                                                    (this.props.blueprint.dental.silver.isSelected && this.props.blueprint.dental.silver.includeMajor) &&
                                                    <div style={ styles.innerBlockTextRow }>
                                                        <CheckIcon color="primary" fontSize="small" />
                                                        <Text small>{ this.props.blueprint.dental.silver.majorReimbursement }% { i18n.t(tokens.labels.signup.majorDental) }</Text>
                                                    </div>
                                                }

                                                {
                                                    (this.props.blueprint.dental.silver.isSelected && this.props.blueprint.dental.silver.includeOrthodontics) &&
                                                    <div style={ styles.innerBlockTextRow }>
                                                        <CheckIcon color="primary" fontSize="small" />
                                                        <Text small>{ this.props.blueprint.dental.silver.orthodonticReimbursement }% { i18n.t(tokens.dropdowns.benefits.orthodontics) }</Text>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <Button
                                        color="primary"
                                        onClick={() => this._toggleDetails('dental', 'silver', Theme.colors.skyBlue, `${ this.props.modularFlexTiers.tier2 } ${ i18n.t(tokens.titles.dental) }`)}
                                        customStyle={ styles.detailsBtn }
                                    >
                                        { i18n.t(tokens.titles.details) }
                                    </Button>
                                </SelectedStyle>

                                {
                                    this.props.modularFlexTiers.numberOfTiers === 3 &&
                                        <SelectedStyle selected={this.state.dental === "bronze"} tier="bronze">
                                            <div style={ styles.clickableArea } onClick={() => this._selectTier('dental', 'bronze')}>
                                                <div style={ styles.titleBlock }>
                                                    <StarsIcon style={{ color: Theme.colors.skyBlue, marginTop: 5 }} fontSize="medium" />

                                                    <div>
                                                        <Text bold mediumLarge>{ this.props.modularFlexTiers.tier3 }</Text>
                                                        <Text superTiny bold color={ Theme.colors.skyBlue } margin="-5px 0 0 0">{ i18n.t(tokens.titles.coverage) }</Text>
                                                    </div>
                                                </div>

                                                <div style={ styles.outerBlock }>
                                                    <div style={ styles.innerBlock }>
                                                        {
                                                            (this.props.blueprint.dental.bronze.isSelected && this.props.blueprint.dental.bronze.includeBasic) &&
                                                            <div style={ styles.innerBlockTextRow }>
                                                                <CheckIcon color="primary" fontSize="small" />
                                                                <Text small>{ this.props.blueprint.dental.bronze.basicReimbursement }% { i18n.t(tokens.labels.signup.basicDental) }</Text>
                                                            </div>
                                                        }

                                                        {
                                                            (this.props.blueprint.dental.bronze.isSelected && this.props.blueprint.dental.bronze.includeMajor) &&
                                                            <div style={ styles.innerBlockTextRow }>
                                                                <CheckIcon color="primary" fontSize="small" />
                                                                <Text small>{ this.props.blueprint.dental.bronze.majorReimbursement }% { i18n.t(tokens.labels.signup.majorDental) }</Text>
                                                            </div>
                                                        }

                                                        {
                                                            (this.props.blueprint.dental.bronze.isSelected && this.props.blueprint.dental.bronze.includeOrthodontics) &&
                                                            <div style={ styles.innerBlockTextRow }>
                                                                <CheckIcon color="primary" fontSize="small" />
                                                                <Text small>{ this.props.blueprint.dental.bronze.orthodonticReimbursement }% { i18n.t(tokens.dropdowns.benefits.orthodontics) }</Text>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <Button
                                                color="primary"
                                                onClick={() => this._toggleDetails('dental', 'bronze', Theme.colors.skyBlue, `${ this.props.modularFlexTiers.tier3 } ${ i18n.t(tokens.titles.dental) }`)}
                                                customStyle={ styles.detailsBtn }
                                            >
                                                { i18n.t(tokens.titles.details) }
                                            </Button>
                                        </SelectedStyle>
                                }
                            </div>

                            <div style={styles.stepperBtnContainer}>
                                <Button
                                    style={styles.stepperNextBtn}
                                    onClick={this._next}
                                    color="primary"
                                >
                                    { i18n.t(tokens.buttons.continue) }
                                </Button>
                            </div>
                        </div>
                }

                {
                    this.state.modalType &&
                        <Modal
                            open={this.state.showDetails}
                            disableBackdropClick
                            title={ this.state.modalTitle }
                            primaryButton={{
                                label: i18n.t(tokens.buttons.close),
                                onClick: () => this._toggleDetails()
                            }}
                            loader={this.props.loader}
                        >
                            {
                                this.props.modularFlexTiers.combinedTierSelection ?
                                    <>
                                        <Text medium bold margin="20px 0">
                                            { i18n.t(tokens.titles.healthcare) }
                                        </Text>

                                        {
                                            this._buildDetails(this.props.blueprint.health[this.state.modalTier].healthcare, 'healthcare')
                                        }

                                        <Text medium bold margin="20px 0">
                                            { i18n.t(tokens.titles.drugs) }
                                        </Text>

                                        {
                                            this._buildDetails(this.props.blueprint.health[this.state.modalTier].drugs, 'drugs')
                                        }

                                        <Text medium bold margin="20px 0">
                                            { i18n.t(tokens.titles.spendingAccounts) }
                                        </Text>

                                        {
                                            this._buildDetails(this.props.blueprint.health[this.state.modalTier].spendingAccounts, 'spendingAccounts')
                                        }

                                        <Text medium bold margin="20px 0">
                                            { i18n.t(tokens.titles.dental) }
                                        </Text>

                                        {
                                            this._buildDetails(this.props.blueprint.dental[this.state.modalTier], 'dental')
                                        }
                                    </>
                                    :
                                    <>
                                        {
                                            this.state.modalType === 'health' ?
                                                <React.Fragment>
                                                    <Text medium bold margin="20px 0">
                                                        { i18n.t(tokens.titles.healthcare) }
                                                    </Text>

                                                    {
                                                        this._buildDetails(this.props.blueprint.health[this.state.modalTier].healthcare, 'healthcare')
                                                    }

                                                    <Text medium bold margin="20px 0">
                                                        { i18n.t(tokens.titles.drugs) }
                                                    </Text>

                                                    {
                                                        this._buildDetails(this.props.blueprint.health[this.state.modalTier].drugs, 'drugs')
                                                    }

                                                    <Text medium bold margin="20px 0">
                                                        { i18n.t(tokens.titles.spendingAccounts) }
                                                    </Text>

                                                    {
                                                        this._buildDetails(this.props.blueprint.health[this.state.modalTier].spendingAccounts, 'spendingAccounts')
                                                    }
                                                </React.Fragment>
                                                :
                                                <React.Fragment>
                                                    {
                                                        this._buildDetails(this.props.blueprint.dental[this.state.modalTier], 'dental')
                                                    }
                                                </React.Fragment>
                                        }
                                    </>
                            }
                        </Modal>
                }

            </div>
        );
    }
}

export default (connect()(ModularFlexSelection));